import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CollectionResource } from '@app/data/resources';
import { TaskComplexityFilterInput } from './inputs';
import { TaskComplexityResource } from './resources';
import { TaskRefList } from './refs';

export default class TaskComplexity {
    private basePath = '/api/task-complexity';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get list of task complexity objects
    get = async (filter: TaskComplexityFilterInput): Promise<CollectionResource<TaskComplexityResource, {}>> => {
        const query = qs.stringify({ ...filter });

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };

    // Process all tasks, queued for complexity recalculation
    processAllQueuedCalculations = async (): Promise<TaskRefList> => {
        const { data } = await this.http.post(`${this.basePath}/compute/queue`);

        return data;
    };

    // Process complexity calculation for specific task ID
    processCalculation = async (taskId: ID): Promise<TaskRefList> => {
        const { data } = await this.http.post(`${this.basePath}/compute/id/${taskId}`);

        return data;
    };
}
